
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 524 524","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M443 81C394.7 32.6 330.4 6 262 6S129.3 32.6 81 81 6 193.6 6 262s26.6 132.7 75 181 112.6 75 181 75 132.7-26.6 181-75 75-112.6 75-181-26.6-132.7-75-181zm-10.6 351.4C386.9 477.9 326.4 503 262 503s-124.9-25.1-170.4-70.6S21 326.4 21 262 46.1 137.1 91.6 91.6 197.6 21 262 21s124.9 25.1 170.4 70.6S503 197.6 503 262s-25.1 124.9-70.6 170.4z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M61.6 252c4.1.4 7.8-2.7 8.1-6.8 4.1-47.9 26-92.4 61.5-125.1C166.9 87.1 213.4 69 262 69s95.1 18.1 130.8 51.1c35.5 32.8 57.4 77.2 61.5 125.1.3 3.9 3.6 6.9 7.5 6.9h.7c4.1-.4 7.2-4 6.8-8.1-4.5-51.7-28-99.6-66.3-134.9C364.5 73.6 314.4 54 262 54s-102.5 19.6-141 55.1C82.7 144.4 59.2 192.3 54.7 244c-.3 4 2.8 7.7 6.9 8zM462.4 272c-4.1-.3-7.8 2.7-8.1 6.8-4.1 47.9-26 92.4-61.5 125.1-35.7 33-82.2 51.1-130.8 51.1s-95.1-18.1-130.8-51.1c-35.5-32.8-57.4-77.2-61.5-125.1-.4-4.1-4-7.2-8.1-6.8-4.1.4-7.2 4-6.8 8.1 4.5 51.7 28 99.6 66.3 134.9 38.5 35.5 88.6 55.1 141 55.1s102.5-19.6 141-55.1c38.3-35.3 61.8-83.2 66.3-134.9.2-4.1-2.9-7.8-7-8.1z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M230.3 230.9v150.4c0 12.8 14.3 23.2 31.9 23.2 17.5 0 32.3-10.6 32.3-23.2V230.9c0-13.2-13.6-22.8-32.3-22.8-18.8 0-31.9 9.4-31.9 22.8zm49.2 0v150.4c0 2-6.3 8.2-17.3 8.2s-16.9-5.8-16.9-8.2V230.9c0-4.4 7.4-7.8 16.9-7.8 10.3 0 17.3 4 17.3 7.8zM262.2 119.5c-19.1 0-34.6 14.2-34.6 31.6 0 17.1 15.8 31.6 34.6 31.6 18.6 0 34.2-14.4 34.2-31.6 0-17.4-15.3-31.6-34.2-31.6zm0 48.1c-11.7 0-19.6-8.6-19.6-16.6 0-9.1 8.8-16.6 19.6-16.6 10.4 0 19.2 7.6 19.2 16.6 0 8.9-9 16.6-19.2 16.6z"}})])
          )
        }
      }
    